export default "__VITE_ASSET__C$Zz_uh9__"